<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" @close="handleClose"
        :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
            <!-- 园区名称 -->
            <el-form-item label="园区名称" prop="name">
                <el-input :disabled="inputDisabled" v-model="form.name" placeholder="请输入园区名称" clearable />
            </el-form-item>

            <!-- 园区特色标签 -->
            <el-form-item label="园区特色标签" prop="labels">
                <el-input :disabled="inputDisabled" v-model="form.labels[0]" placeholder="请输入特色标签" clearable
                    style="width: 150px" />
                <el-input :disabled="inputDisabled" v-model="form.labels[1]" placeholder="请输入特色标签" clearable
                    style="width: 150px; margin-left: 10px" />
            </el-form-item>

            <el-form-item label="园区星级" prop="star">
                <el-select :key="`select-${inputDisabled}`" :disabled="inputDisabled" v-model.number="form.star"
                    placeholder="请选择园区星级" clearable style="width: 150px;">
                    <el-option label="0 星(无评级)" :value="0" />
                    <el-option v-for="i in 5" :key="i" :label="`${i} 星`" :value="i" />
                </el-select>
            </el-form-item>

            <!-- 概要介绍（带字数统计） -->
            <el-form-item label="概要介绍 (50字)" prop="summary">
                <el-input :disabled="inputDisabled" v-model="form.summary" placeholder="请输入园区概要介绍" clearable
                    @input="handleSummaryInput" />
                <div style="text-align: right; font-size: 12px; color: #999">
                    还可输入 {{ remainingChars }} 个字
                </div>
            </el-form-item>

            <!-- 园区简介（富文本） -->
            <el-form-item label="园区简介" prop="introduction">
                <vue-editor v-if="dialogVisible" :disabled="inputDisabled" v-model="form.introduction"
                    useCustomImageHandler @image-added="handleImageAdded" />
            </el-form-item>

            <!-- 园区位置标记（Leaflet 地图） -->
            <el-form-item label="园区位置标记" prop="centerPoint">
                <!-- v-if="dialogVisible"用于每次dialog弹框 都重新创建和渲染 map -->
                <div v-if="dialogVisible" id="map_container" style="height: 300px;"></div>
            </el-form-item>
        </el-form>
        <!-- 底部按钮 -->
        <template v-if="type != 'view'" #footer>
            <span class="dialog-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" :loading="submitLoading" :disabled="submitLoading"
                    @click="handleSubmit">提交</el-button>
            </span>
        </template>

    </el-dialog>
</template>

<script>
import { initMap, clearMarkers } from '@/utils/mapUtil/funcs'
import { findParkById, addOrUpdatePark } from "@/api/projectManage";
import { wgs84togcj02, gcj02towgs84 } from 'coordtransform'
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor"
import { uploadFile } from '@/api/fileApi';

export default {
    name: 'AddUpdateViewParkDialog',
    components: {
        VueEditor
    },
    props: {
        // 弹窗标题，新增/编辑区分
        dialogTitle: {
            type: String,
            default: '新增园区'
        },
        //查看 新增 更新
        type: {
            type: String,
            default: 'add'
        },
        //园区id
        parkId: {
            required: false,
            type: String,
            default: ''
        },
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                id: '',
                name: '',
                star: 0,
                labels: [], // 园区特色标签
                summary: '', // 概要介绍
                introduction: '', // 园区简介
                centerPoint: [], // 坐标
            },
            remainingChars: 50, // 剩余可输入字数
            quillOptions: {
                theme: 'snow'  // quill 富文本配置，可按需扩展
            },
            submitLoading: false,
            map: null,
            marker: null,

            rules: {
                name: [
                    { required: true, message: '园区名称不能为空', trigger: 'blur' }
                ],
                summary: [
                    { max: 50, message: '不超过50字', trigger: 'blur' }
                ]
            }
        };
    },
    watch: {
        // 监听弹窗显示状态，初始化地图
        dialogVisible(val) {
            if (val) {
                this.$nextTick(async () => {
                    await this.initData()
                    this.initMap();
                    this.bindMapClick();
                })
            } else {
                this.unbindMapClick();
            }
        }
    },
    computed: {
        ...mapGetters(["userInfo", "identityObj"]),
        inputDisabled() {
            return this.type === 'view'
        }
    },
    methods: {

        // 绑定地图点击事件
        bindMapClick() {
            if (!this.map) return;
            this.map.on('click', this.handleMapClick);
        },

        // 解绑地图点击事件
        unbindMapClick() {
            if (!this.map) return;
            this.map.off('click', this.handleMapClick);
        },

        // 点击地图时的处理
        handleMapClick(e) {
            let wgs84lat = e.latlng.lat
            let wgs84lng = e.latlng.lng
            clearMarkers(this.map.tempLayer)
            this.marker = L.marker([wgs84lat, wgs84lng]).addTo(this.map.tempLayer);
            const [gcjlng, gcjlat] = wgs84togcj02(wgs84lng, wgs84lat)
            this.form.centerPoint = [gcjlng, gcjlat]
        },

        // 初始化地图
        initMap() {
            this.map = initMap("map_container")
            this.setMarker(this.form.centerPoint[1], this.form.centerPoint[0])
        },

        //初始化当前园区数据
        async initData() {
            if (this.type === 'add') {
                let [lon, lat] = this.identityObj.centerPoint.split(",")
                this.form.centerPoint = [lon, lat]
                // console.log(this.identityObj,'this.identityObj')
                return
            }
            let res = await findParkById({ id: this.parkId });
            if (res.success) {
                // console.log('res.data', res.data)
                this.form.id = res.data.id
                this.form.name = res.data.name
                this.form.star = res.data.star
                this.form.labels = res.data.labels || []
                this.form.summary = res.data.summary
                this.form.introduction = res.data.introduction
                this.form.centerPoint = res.data.centerPoint
            }
        },

        // 设置标记并缩放地图(纬经度)
        setMarker(lat, lng) {
            clearMarkers(this.map.tempLayer)
            const [wgs84lng, wgs84lat] = gcj02towgs84(lng, lat)
            this.marker = L.marker([wgs84lat, wgs84lng]).addTo(this.map.tempLayer);
            this.map.setView([wgs84lat, wgs84lng], 13);
            this.form.centerPoint = [lng, lat]
        },

        // 概要介绍输入监听，计算剩余字数
        handleSummaryInput() {
            const maxLength = 50;
            const currentLength = this.form.summary.length;
            this.remainingChars = maxLength - currentLength;
        },


        // 取消按钮
        handleCancel() {
            this.handleClose()
        },

        async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            const formData = new FormData()
            formData.append("file", file)
            formData.append("catalog", "park-management");
            try {
                let res = await uploadFile(formData);
                // let fileName = res.data.sourceFileName;
                let url = window.globalUrl.HOME_API + "/admin/file/get?ossFilePath=" + res.data.url;
                Editor.insertEmbed(cursorLocation, "image", url)
                resetUploader()
            } catch (err) {
                console.error(err)
            }
        },

        // 提交按钮
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    // 开始提交，锁定按钮
                    this.submitLoading = true;
                    try {
                        let dto = {
                            ...this.form,
                        }
                        console.log(dto, 'dto-------')
                        let res = await addOrUpdatePark(dto);
                        if (res.success) {
                            this.$message.success("操作成功");
                            this.handleClose()
                            this.$emit('load')
                        } else {
                            this.$message.error(res.msg);
                        }
                    } catch (error) {
                        console.error("提交失败:", error);
                    } finally {
                        // 无论成功失败，都解除锁定
                        this.submitLoading = false;
                    }
                }
            });
        },

        // 关闭弹窗回调
        handleClose() {
            this.resetForm();
            this.dialogVisible = false;
        },

        // 重置表单
        resetForm() {
            this.form = {
                name: '',
                labels: [],
                star: 0,
                summary: '',
                introduction: '',
                centerPoint: [],
            };
            this.remainingChars = 50;
            if (this.marker) {
                this.map.tempLayer.removeLayer(this.marker);
                this.marker = null;
            }
        }
    }
};
</script>

<style scoped>
/* 调整富文本编辑器样式，适配弹窗 */
.ql-editor {
    min-height: 100px;
}

/* 地图容器初始化隐藏滚动条（可选） */
#parkMap {
    overflow: hidden;
}
</style>